export default "__VITE_ASSET__BGiQpVFI__"